import {Component, Input} from '@angular/core';
import {Router} from "../../../services/back/router.service";

@Component({
  selector: 'app-router-icon',
  standalone: true,
  templateUrl: './router-icon.component.html',
  styleUrl: './router-icon.component.scss'
})
export class RouterIconComponent {
	@Input() router: Router;
	@Input() size: number = 30;
}
